import { FlattenedItem, ItemId, Path, TreeData, TreeItem } from '../types';

export const flattenTree = (tree: TreeData, path: Path = []): FlattenedItem[] =>
  tree.items[tree.rootId]
    ? tree.items[tree.rootId].children.reduce<FlattenedItem[]>(
        (accum: FlattenedItem[], itemId: ItemId) => {
          const item = tree.items[itemId];
          const currentPath = [...path, itemId];
          const currentItem = { item, path: currentPath };
          const children =
            item && item.isExpanded
              ? flattenTree({ rootId: item.id, items: tree.items }, currentPath)
              : [];

          return [...accum, currentItem, ...children];
        },
        [],
      )
    : [];

export const assocTree = (
  itemId: ItemId,
  props: Partial<TreeItem>,
  tree: TreeData,
): TreeData => {
  const match = tree.items[itemId];

  if (!match) {
    return tree;
  }

  return {
    rootId: tree.rootId,
    items: {
      ...tree.items,
      [itemId]: { ...match, ...props },
    },
  };
};
